"use strict";
angular.module("planCommandManuscriptAnalysisRouterModule", [])
    .config(["$stateProvider", function($stateProvider) {
        $stateProvider
            .state("front.planningresource.commandMonitor.manuscriptanalysis",{
                url: '/manuscriptanalysis',
                views:{
                    'main@front.planningresource.commandMonitor':{
                        templateUrl: './planningResource/commandMonitor/manuscriptAnalysis/manuscriptAnalysis_tpl.html',                                    
                        controller: 'planCommandMonitorManuscriptAnalysisCtrl'
                    }
                }
            }).state("front.planningresource.commandMonitor.manuscriptanalysis.rankinglist", {
                url: '/rankinglist',
                views: {
                    'main@front.planningresource.commandMonitor.manuscriptanalysis': {
                        templateUrl: './planningResource/commandMonitor/manuscriptAnalysis/rankingList/rankingList_tpl.html',
                        controller: 'planCommandMonitorRankingListController',
                    },
                    'nav@front.planningresource.commandMonitor.manuscriptanalysis': {
                        templateUrl: './planningResource/commandMonitor/manuscriptAnalysis/manuscriptAnalysisNav_tpl.html',                                      
                        controller: 'manuscriptAnalysisNavController',
                    }
                }
            }).state("front.planningresource.commandMonitor.manuscriptanalysis.custommanuscriptprop", {
                url: '/custommanuscriptprop',
                views: {
                    'main@front.planningresource.commandMonitor.manuscriptanalysis': {
                        templateUrl: './planningResource/commandMonitor/manuscriptAnalysis/customManuscriptProp/customManuscriptProp_tpl.html',
                        controller: 'planCommandMonitorCustomManuscriptPropController',
                    },
                    'nav@front.planningresource.commandMonitor.manuscriptanalysis': {
                        templateUrl: './planningResource/commandMonitor/manuscriptAnalysis/manuscriptAnalysisNav_tpl.html',
                        controller: 'manuscriptAnalysisNavController',
                    }
                }
            }).state("front.planningresource.commandMonitor.manuscriptanalysis.addeditcustommanuscriptprop", {
                url: '/addeditcustommanuscriptprop?id',
                views: {
                    'main@front.planningresource.commandMonitor.manuscriptanalysis': {
                        templateUrl: './planningResource/commandMonitor/manuscriptAnalysis/customManuscriptProp/addEditCustomManuscriptProp/addEditCustomManuscriptProp.html',
                        controller: 'addEditcustomManuscriptPropCtrl',
                    }
                }
            });
    }]);
